<template lang="pug">
div
  header.c-page-header.c-page-header--no-margin
    .row.narrow
      .column
        h1.c-page-header__title {{$t('results.title')}}
        .c-page-header__content
          .c-page-header__counter
            .c-counter
              Counter(:percentage="global_score")
              .c-counter__content
                .c-page-header__value(data-purpose="global_result_percentage")
                  | {{score}}
                  span.c-page-header__percentage %
          .c-page-header__text
            p {{$t('results.score_details', { global_score: global_score })}}
            a.button.success.large(:href="seraphinLink" target="_blank") {{$t('results.sign_up')}}
        ul.c-page-header__data-list
          li.c-page-header__data-item(v-for="element in risk_object_scores")
            .c-page-header__data-value
              | {{element['score']}}
              span.c-page-header__percentage %
            .c-counter.c-counter--small
              Counter(:percentage="element['score']", small=true)
              .c-counter__content
                Icon(:icon="element['risk_object']" classes="p-icon--2x")

    .row.narrow.u-margin-top-4x
      .column
        h2.p-title.p-title--tag {{$t('results.advices')}}
        p {{$t('results.protection_improve')}}
        div(v-for="element in advicedHighCriticalityCovers")
          div(v-for="cover in element['covers']")
            .c-card.c-card--alert
              .c-card__header.c-card__header--image(:style="{ backgroundImage: 'url(./static/assets/img/results/' + element['risk_object'] + '.jpg)' }")
                h3.c-card__title {{$t(`shared.insurances.${element['risk_object']}_${cover}`)}}
                .c-card__tag
                  svg.p-icon p-icon
                    use(:href="'#svg-'.concat(element['risk_object'])")
                  | {{$t(`shared.risk_objects.personalized.${element['risk_object']}`)}}
                .p-tag.p-tag--alert {{$t('results.criticality.high')}}
              .c-card__banner(v-if="recommendedByCrowd(element['risk_object'], cover)")
                p.c-card__caption {{$t('results.caption')}}
              .c-card__content
                | {{$t(`shared.insurances.${element['risk_object']}_${cover}_description`)}}
              .c-card__footer
                .c-card__action
                  .button-group
                    a.button.success(:href="$t(`shared.insurances.${element['risk_object']}_${cover}_link`).concat('?utm_source=checkup')" target='_blank') {{$t('results.ask_for_an_offer')}}
        div(v-for="element in advicedMediumCriticalityCovers")
          div(v-for="cover in element['covers']")
            .c-card.c-card--warning
              .c-card__header.c-card__header--image(:style="{ backgroundImage: 'url(./static/assets/img/results/' + element['risk_object'] + '.jpg)' }")
                h3.c-card__title {{$t(`shared.insurances.${element['risk_object']}_${cover}`)}}
                .c-card__tag
                  svg.p-icon p-icon
                    use(:href="'#svg-'.concat(element['risk_object'])")
                  | {{$t(`shared.risk_objects.personalized.${element['risk_object']}`)}}
                .p-tag.p-tag--warning {{$t('results.criticality.medium')}}
              .c-card__content
                | {{$t(`shared.insurances.${element['risk_object']}_${cover}_description`)}}
              .c-card__footer
                .c-card__action
                  .button-group
                    a.button.success(:href="$t(`shared.insurances.${element['risk_object']}_${cover}_link`).concat('?utm_source=checkup')" target='_blank') {{$t('results.ask_for_an_offer')}}
    .row.narrow.u-margin-top-4x
      .column
        h2.p-title.p-title--tag {{$t('results.summary')}}
        p {{$t('results.detailed_analysis')}}
        .c-card
          .c-card__content
            table.c-table.stack
              thead.c-table__head
                tr.c-table__row.c-table__cell--object-risk
                  th.c-table__cell {{$t('results.risk_object')}}
                  th.c-table__cell {{$t('results.current_covers')}}
                  th.c-table__cell {{$t('results.missing_covers')}}
              tbody
                tr.c-table__row(v-for="element in risk_object_scores")
                  td.c-table__cell.c-table__cell--object-risk
                    h2.p-title(v-html="$t(`shared.risk_objects.personalized.${element['risk_object']}`)")
                    .c-counter.c-counter--small(:class="`c-counter--${percentageColor(element['score'])}`")
                      Counter(:percentage="element['score']", small=true)
                      .c-counter__content
                        Icon(:icon="element['risk_object']" classes="p-icon--2x")
                    .p-tag.p-tag--uppercase(:class="`p-tag--${percentageColor(element['score'])}`") {{element['score']}}%
                  td.c-table__cell
                    ul.p-list-bare
                      li(v-for="covered_risk in element['covered_risks']") {{$t(`shared.insurances.${element['risk_object']}_${covered_risk['reference']}`)}}
                  td.c-table__cell
                    ul.p-list-bare
                      li(v-for="uncovered_risk in element['uncovered_risks']")
                        | {{$t(`shared.insurances.${element['risk_object']}_${uncovered_risk['reference']}`)}}
                        span.p-tag.p-tag--uppercase.p-tag--right(:class="`p-tag--${coveringColor(uncovered_risk['criticality'])}`")
                          | {{$t(`results.criticality.${uncovered_risk['criticality']}`)}}
    .text-center.u-margin-top-8x
      h2.p-title.p-title--medium.u-margin-bottom-4x {{$t('results.manage')}}

      a.button.success.large(:href="seraphinLink" target="_blank") {{$t('results.sign_up')}}
</template>

<script>
import Counter from './shared/Counter'
import Icon from './shared/Icon'
import axiosInstance from '../config/axios-check-up'

export default {
  components: {
    Counter,
    Icon
  },
  created () {
    document.title = 'Seraphin - Check-up - Résultats'
  },
  data () {
    return {
      global_score: 0,
      score: 0,
      covers_prioritization: {
        high: [],
        medium: [],
        low: []
      },
      risk_object_scores: [],
      maxNumberAdvicedCovers: 3
    }
  },
  mounted () {
    this.$store.commit('setLoading', true)
    axiosInstance.post('', this.checkupData)
    .then(res => {
      this.global_score = res.data.global_score
      this.covers_prioritization = res.data.covers_prioritization
      this.risk_object_scores = res.data.risk_object_scores
      this.$store.commit('setLoading', false)
      this.loadScore()
    })
    .catch(err => console.log(err))
  },
  computed: {
    seraphinLink () {
      return `${process.env.SERAPHIN_PATH}/fr`
    },
    checkupData () {
      return this.$store.getters.buildCheckupData
    },
    advicedHighCriticalityCovers () {
      let highCriticalityCovers = this.covers_prioritization.high
      let advicedCovers = highCriticalityCovers.slice(0, this.maxNumberAdvicedCovers)
      return advicedCovers
    },
    advicedMediumCriticalityCovers () {
      let mediumCriticalityCovers = this.covers_prioritization.medium
      let numberAdvicedHighCriticalityCovers = this.advicedHighCriticalityCovers.length

      if (numberAdvicedHighCriticalityCovers === this.maxNumberAdvicedCovers) return []

      let numberAdvicedMediumCriticalityCovers = this.maxNumberAdvicedCovers - numberAdvicedHighCriticalityCovers
      let advicedCovers = mediumCriticalityCovers.slice(0, numberAdvicedMediumCriticalityCovers)

      return advicedCovers
    }
  },
  methods: {
    async loadScore () {
      for (let i = 0; i < this.global_score; i++) {
        // await a timeout only works with a Promise
        await new Promise(resolve => setTimeout(resolve, 20))
        this.score++
      }
    },
    recommendedByCrowd (riskObject, risk) {
      if (this.risk_object_scores === []) return false
      let riskObjectScore = this.risk_object_scores.filter(function (x) { return x['risk_object'] === riskObject })[0]
      let risksScores = riskObjectScore.uncovered_risks.filter(function (x) { return x['reference'] === risk })[0]
      return risksScores['recommended_by_crowd'] === 'true'
    },
    coveringColor (covering) {
      if (covering === 'high') return 'alert'
      if (covering === 'medium') return 'warning'
      if (covering === 'low') return 'info'
      return 'primary'
    },
    percentageColor (percentage) {
      if (percentage < 30) return 'alert'
      if (percentage < 50) return 'warning'
      if (percentage < 80) return 'info'
      return 'success'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Results.vue